import { sideBarNavigate } from "../partnerWeb_Dashboard/utils";
import { ROUTE } from "../../routes";
export const onChangeTab = async (action, _datastore, standardUtilities) => {
    console.warn(`**** onChangeTab ****`);
    await sideBarNavigate(standardUtilities, action);
};
export const openMenu = async (action, _datastore, { navigate }) => {
    console.warn('**** onKnowMore leads Action Triggered ****', action);
    await navigate(ROUTE.PARTNER_MENU, {
        routeId: action.routeId
    });
};
